import { render } from "./HomeWorldCup.vue?vue&type=template&id=257db58a&scoped=true&ts=true"
import script from "./HomeWorldCup.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeWorldCup.vue?vue&type=script&setup=true&lang=ts"

import "./HomeWorldCup.vue?vue&type=style&index=0&id=257db58a&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257db58a"],['__file',"src/components/home/HomeWorldCup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "257db58a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('257db58a', __exports__)) {
    console.log('reload')
    api.reload('257db58a', __exports__)
  }
  
  module.hot.accept("./HomeWorldCup.vue?vue&type=template&id=257db58a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('257db58a', render)
  })

}


export default __exports__